// import RequestTable from './RequestTable';
import { TrackRequest } from './TrackRequest';
import { SeeAll } from '../Components/SeeAll';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { MdAccountCircle } from 'react-icons/md';
import { LoadingMode } from '../Components/LoadingMode';
import { LiaStarSolid } from 'react-icons/lia';
import { DefaultTable } from '../Components/DefaultTable';
import { COLUMNS } from './Column';
import {
  formatAmount,
  formatDateStrToDate,
  formatRating,
  getToken,
} from '../utils';

const TransactionRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [bidDependency, setBidDependency] = useState(false);

  const [pendingTransactionData, setPendingTransactionData] = useState([]);
  const [bidUsers, setBidUsers] = useState([]);
  const [getDataById, setGetDataById] = useState({});

  const [zindex, setZindex] = useState(false);
  const [cxId, setCxId] = useState(null);
  const [defaultData, setDefaultData] = useState({});

  const userToken = getToken()?.token;

  useEffect(() => {
    const getBuyOffers = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/cx-transaction/my-ongoing-transactions`,

          { headers: { Authorization: `Bearer ${userToken}` } }
        );

        setPendingTransactionData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    getBuyOffers();
  }, [userToken]);

  const handleGetId = (dataId) => {
    const findDatabyId = pendingTransactionData?.find((data) => {
      return data?.id === dataId;
    });

    setCxId(dataId);
    setGetDataById(findDatabyId);
    setBidDependency(true);
  };

  const pendingTableDatas = pendingTransactionData?.map((data) => ({
    // date: <span>{formatTimeStampToDate(Number(data?.deadline))}</span>,
    date: <span>{`${formatDateStrToDate(data?.created_at)}`}</span>,
    // currency: (
    //   <p className="flex flex-row items-center gap-2">
    //     <img
    //       src={data?.quote_currency?.country?.flag}
    //       alt="currency flag"
    //       className="w-5 h-[13px]"
    //     />
    //     {data?.quote_currency?.name} ({data?.quote_currency?.symbol})
    //   </p>
    // ),
    amount: (
      <p className='flex flex-row justify-center items-center gap-2 w-full'>
        <img
          src={data?.quote_currency?.country?.flag}
          alt='currency flag'
          className='w-5 h-[13px]'
        />
        {`${formatAmount(data?.amount * 1)}`}
        <span>{data?.quote_currency?.symbol} </span>
      </p>
    ),
    rate: `${formatAmount(data?.rate)} ${data?.base_currency?.symbol}`,
    status: (
      <p
        className={`py-[2px] rounded ${
          data?.transaction_status?.name === 'Bid'
            ? 'bg-orange-500/10 text-orange-500'
            : data?.transaction_status?.name === 'Accept'
            ? 'bg-b-mct text-b-mc'
            : data?.transaction_status?.name === 'Payment'
            ? 'bg-green-500/10 text-green-500'
            : 'text-b-mc bg-b-mct'
        }`}
      >
        {data?.transaction_status?.name === 'Pending'
          ? 'Avaliable'
          : data?.transaction_status?.name === 'Bid'
          ? `${data?.transaction_status?.name} (${data?.bid_count})`
          : data?.transaction_status?.name}
      </p>
    ),
    buyer_seller: (
      <div className='flex flex-row items-start gap-2'>
        <span className='text-4xl text-b-mc/70'>
          <MdAccountCircle />
        </span>
        <div className='flex flex-col justify-start text-left'>
          <p>{data?.unique_code}</p>
          <div className='flex flex-col gap- text-sm'>
            <p className='flex flex-row items-center gap-1 text-s-bk'>
              Rating: {formatRating(data?.user?.rating)}{' '}
              <span className='text-green-500 -m-1'>
                <LiaStarSolid />
              </span>
            </p>{' '}
            {/* <p className="flex flex-row items-center gap-1 text-s-bk">
              Order: {data?.user.trx_stats?.completed}{" "}
              <span className="text-green-500 -m-1">{<BiTransfer />}</span>
            </p> */}
          </div>
        </div>
      </div>
    ),
    action: (
      <button
        className='text-p-wh px-6 py-1.5 rounded-md text-[10px] w-fit active:bg-t-bk hover:bg-orange-600 bg-orange-500'
        onClick={() => handleGetId(data?.id)}
      >
        View
      </button>
    ),
  }));

  useEffect(() => {
    const handleGetdefaultData = () => {
      if (pendingTransactionData?.length !== 0) {
        setDefaultData(pendingTransactionData[0]);
      }
    };
    handleGetdefaultData();
  }, [pendingTransactionData]);

  useEffect(() => {
    let data = {
      cx_id: cxId,
    };

    if (bidDependency) {
      const getCXbids = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/cx-transaction/bids`,
            data,
            {
              headers: {
                Authorization: `Bearer ${userToken}`,
              },
            }
          );
          setBidUsers(response.data);
          setBidDependency(false);
        } catch (error) {
          console.log(error);
          setCxId(null);
          setBidDependency(false);
        }
      };
      getCXbids();
    }
  }, [bidDependency, cxId, userToken]);

  const handleToggleZindex = () => {
    if (!zindex) {
      setZindex(true);
    } else {
      setZindex(false);
    }
  };

  return (
    <div className='flex md:px-6 py-6 mt-4 flex-col gap-16'>
      <div className='flex flex-col gap-6 overflow-hidden'>
        <span className='block px-4 md:0'>
          <SeeAll name='Transacton Request' seeAll={false} />
        </span>

        {Object.keys(getDataById)?.length !== 0 && (
          <TrackRequest
            trackRequestData={{
              getDataById,
              bidUsers,
              handleToggleZindex,
              setZindex,
            }}
          />
        )}
      </div>

      {isLoading ? (
        <LoadingMode />
      ) : pendingTableDatas.length === 0 ? (
        <p className='text-center texxt-red-500 p-6 bg-p-bk/5'>
          You have no ongoing transaction.
        </p>
      ) : (
        <div className={`overflow-x-auto ${zindex ? '-z-20' : ''}`}>
          <DefaultTable columns={COLUMNS} data={pendingTableDatas} />
          {/* <RequestTable requestData={pendingTableDatas} /> */}
        </div>
      )}
    </div>
  );
};
export default TransactionRequest;
